import { render, staticRenderFns } from "./MasterCard.vue?vue&type=template&id=62ccbe42&scoped=true&"
import script from "./MasterCard.vue?vue&type=script&lang=js&"
export * from "./MasterCard.vue?vue&type=script&lang=js&"
import style0 from "./MasterCard.vue?vue&type=style&index=0&id=62ccbe42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ccbe42",
  null
  
)

export default component.exports